<template>
  <Form class="search-filter-section grid-x grid-margin-x">
    <div
      v-if="isBcom"
      class="cell hide-for-large margin-bottom-xxs search-bar-wrapper"
    >
      <InputText
        v-model="searchValue"
        name="search-reviews"
        label="Search topic and reviews"
        text="Search"
        text-type="primary"
        @onTextClick="handleSearchButtonClick"
        @onClear="handleSearchClearance"
      />
    </div>
    <div
      v-if="!searchQuery"
      id="reviewFilterBy"
      class="cell small-6 large-2"
    >
      <Dropdown
        v-model="sortBy"
        label="Sort by"
        name="sort-by"
        :options="SORT_BY_OPTIONS"
      />
    </div>
    <div :class="`cell small-${searchQuery ? 12 : 6} large-2`">
      <Dropdown
        v-model="starFiltering"
        label="Filter by"
        name="filter-by"
        :options="filterByValidOptions"
      />
    </div>
    <div
      v-if="isBcom"
      class="cell show-for-large large-4 search-bar-wrapper"
    >
      <InputText
        v-model="searchValue"
        name="search-reviews"
        label="Search topic and reviews"
        text="Search"
        text-type="primary"
        @onTextClick="handleSearchButtonClick"
        @onClear="handleSearchClearance"
      />
    </div>
  </Form>
</template>

<script setup>
import { computed, ref, watch } from 'vue';
import InputText from '@atomic-ui/inputText';
import Form from '@atomic-ui/form';
import Dropdown from '@atomic-ui/dropdown';

import { useProduct } from '@modules/product';
import { useReviews } from '@composables/reviews/useReviews';
import { useReviewsStatistics } from '@composables/reviews/useReviewsStatistics';
import { trackEvent } from '@utils/bvPixel';

import { useBrand } from '@composables/useBrand';
import {
  FILTER_BY_OPTIONS,
  SORT_BY_OPTIONS,
  ALL_STAR_RATINGS_VALUE,
} from '../../constants/reviews';

const {
  sortBy: rawSortBy,
  starFiltering: rawStarFiltering,
  handleSortByChange,
  handleFilterByChange,
  handleSearchQueryChange,
  searchQuery,
  expandReviews,
} = useReviews();

const { countPerRating } = useReviewsStatistics();

const { productId } = useProduct();

const sortBy = computed({
  get() {
    return rawSortBy.value;
  },
  set(updatedSortBy) {
    expandReviews();
    handleSortByChange(updatedSortBy);
    trackEvent('sort', productId, updatedSortBy);
  },
});

const filterByValidOptions = computed(() => {
  const validStarOptions = countPerRating.value.reduce((accumulator, starRating) => {
    if (starRating.count > 0) accumulator.push(starRating.rating);
    return accumulator;
  }, []);
  validStarOptions.push(ALL_STAR_RATINGS_VALUE);

  const filterdOptions = FILTER_BY_OPTIONS.map((option) => {
    if (!validStarOptions.includes(option.value)) {
      return { ...option, disabled: true };
    }
    return option;
  });

  return filterdOptions;
});

const starFiltering = computed({
  get() {
    return String(rawStarFiltering.value);
  },
  set(updatedStarFilteringValue) {
    expandReviews();
    handleFilterByChange(updatedStarFilteringValue);
    trackEvent('filter', productId, 'stars', updatedStarFilteringValue);
  },
});

const { isBcom } = useBrand();

const searchValue = ref('');
const handleSearchButtonClick = () => {
  handleSearchQueryChange(searchValue.value);
  trackEvent('search', productId, searchValue.value);
};
const handleSearchClearance = () => handleSearchQueryChange('');

// fires when the value is reset from outside, e.g. by clicking "frequently mentioned"
watch(searchQuery, () => {
  if (searchQuery.value !== searchValue.value) {
    searchValue.value = searchQuery.value;
  }
});
</script>

<style scoped lang="scss">
.search-filter-section {
  div.search-bar-wrapper {
    margin-left: auto;
  }
}
</style>
